<template>
    <div class="tpl-page-container">
        <SideBar></SideBar>
        <DashView v-if="!view_id"></DashView>
        <LearnView v-if="view_id=='learning'"></LearnView>
        <MylogView v-if="view_id=='mylog'"></MylogView>
        <MomentsView v-if="view_id=='moments'"></MomentsView>
        <MomentsView v-if="view_id=='management'"></MomentsView>
        <AppsView v-if="view_id=='apps'"></AppsView>
        <GroupsView v-if="view_id=='groups'"></GroupsView>
        <DiscussView v-if="view_id=='discuss'"></DiscussView>
        <FollowView v-if="view_id=='follow'"></FollowView>
        <CollectView v-if="view_id=='collect'"></CollectView>
        <RecycleView v-if="view_id=='recycle'"></RecycleView>
    </div>
</template>

<script type="text/javascript">
    import SideBar from '@/components/common_components/side_bar/side_menu.vue'

    import DashView from '@/components/main_page/dashboard.vue'
    import LearnView from '@/components/main_page/learning.vue'
    import MylogView from '@/components/main_page/mylog.vue'
    import MomentsView from '@/components/main_page/mylog.vue'
    import AppsView from '@/components/main_page/appsview.vue'
    import GroupsView from '@/components/main_page/mylog.vue'
    import DiscussView from '@/components/main_page/mylog.vue'
    import FollowView from '@/components/main_page/follow.vue'
    import CollectView from '@/components/main_page/collect.vue'
    import RecycleView from '@/components/main_page/mylog.vue'

    import {mapActions} from 'vuex'
    import {mapState} from 'vuex'

    export default {
        components: {
            SideBar,
            DashView,
            LearnView,
            MylogView,
            MomentsView,
            AppsView,
            GroupsView,
            DiscussView,
            FollowView,
            CollectView,
            RecycleView
        },
        computed: {
            ...mapState({
                view_id: state => state.main.view_id
            })
        },
        methods: {
            ...mapActions({
                change_main_view: 'main/change_main_view'
            })
        },
        watch: {
            '$route': function () {
                this.change_main_view(this.$route.params.view_id)
                //     this.change_index_content(),
                // this.change_dashboard_content(this.$route.query)
            }
        },
        mounted: function () {
            this.change_main_view(this.$route.params.view_id)
        }
    }
</script>
<style type="text/css">
</style>
